import { memo } from 'react';

import { TableHeaderElement } from '../tableHeaderElement';

type ArchiveDisplayMenuProps = {
  archiveClicked?: boolean;
  onClickArchive: () => void;
  shrinkRightIcons?: boolean;
};

function getLabel(shrinkRightIcons?: boolean, archiveClicked?: boolean) {
  if (shrinkRightIcons) return;
  return archiveClicked ? 'Unarchived' : 'Archived';
}

export const ArchiveDisplayMenu = memo<ArchiveDisplayMenuProps>(
  ({ archiveClicked, onClickArchive, shrinkRightIcons }) => (
    <TableHeaderElement
      clicked={archiveClicked ?? false}
      icon="lucide_Archive"
      label={getLabel(shrinkRightIcons, archiveClicked)}
      onClick={onClickArchive}
      tooltip={
        archiveClicked
          ? 'Currently showing archived traces — click to show unarchived'
          : 'Currently showing unarchived traces — click to show archived'
      }
    />
  )
);
